import React, { useState, useRef, useEffect } from "react";
import TTGImage12 from "../../assets/ttgimage12.jpg";
import TTGImage13 from "../../assets/ttgimage13.jpg";
import TTGImage14 from "../../assets/ttgimage14.jpg";
import TTGImage15 from "../../assets/ttgimage15.jpg";
import TTGImage16 from "../../assets/ttgimage16.jpg";
import TTGImage17 from "../../assets/ttgimage17.jpg";
import ttgimage18 from "../../assets/ttgimage18.jpg";
import TTGImage19 from "../../assets/ttgimage19.jpg";
import TTGImage20 from "../../assets/ttgimage20.jpg";
import TTGImage21 from "../../assets/ttgimage21.jpg";
import TTGImage22 from "../../assets/ttgimage22.jpg";
import TTGImage23 from "../../assets/ttgimage23.jpg";
import TTGImage24 from "../../assets/ttgimage24.jpg";
import TTGImage25 from "../../assets/ttgimage25.jpg";
import TTGImage26 from "../../assets/ttgimage26.jpg";
import TTGImage27 from "../../assets/ttgimage27.jpg";
import TTGImage28 from "../../assets/ttgimage28.jpg";
import TTGImage29 from "../../assets/ttgimage29.jpg";
import TTGImage30 from "../../assets/ttgimage30.jpg";
import TTGImage31 from "../../assets/ttgimage31.jpg";
import TTGImage32 from "../../assets/ttgimage32.jpg";
import TTGImage33 from "../../assets/ttgimage33.jpg";

import "./TjänsterArbete.css";

const TjänsterArbeteTakTillGolv = () => {
  const [showSecondBox, setShowSecondBox] = useState(false);
  const secondBoxRef = useRef();
  const mainImageRef = useRef();
  const images = [TTGImage12, TTGImage13, TTGImage14, TTGImage15];
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    if (showSecondBox && secondBoxRef.current) {
      secondBoxRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [showSecondBox]);

  useEffect(() => {
    // Show the initial image directly
    document.querySelector(".ttg-4-images-1").style.opacity = 1;
  
    const interval = setInterval(() => {
      // Fade out the current image
      document.querySelector(".ttg-4-images-1").style.opacity = 0;
      setTimeout(() => {
        setCurrentImageIndex((prevIndex) =>
          prevIndex === images.length - 1 ? 0 : prevIndex + 1
        );
        // Fade in the new image after a short delay
        setTimeout(() => {
          document.querySelector(".ttg-4-images-1").style.opacity = 1;
        }, 850);
      }, 400);
    }, 3000);
  
    return () => clearInterval(interval);
  }, [images, setCurrentImageIndex]);
    
  const handleScrollDownAndToggle = () => {
    setShowSecondBox(true);
  };

  const handleCloseSecondBox = () => {
    setShowSecondBox(false);

    if (mainImageRef.current) {
      mainImageRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const handleTitleClick = (title) => {
    setShowSecondBox(true);

    const targetElement = document.getElementById(title);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div className="tjänster-TakTillGolv-1-parallax-container">
      <div className="tjänster-TakTillGolv-1-parallax-image" ref={mainImageRef}>
      <div className="tjänster-TakTillGolv-1-parallax-image-31231232">
 
        <div className="tjänster-TakTillGolv-1-parallax-image-22">Tjänster</div>
        <div
          className="tjänster-TakTillGolv-1-parallax-image-232"
          onClick={() => handleTitleClick("renovering")}
        >
          Renovering av Bostäder
        </div>
        <div
          className="tjänster-TakTillGolv-1-parallax-image-232"
          onClick={() => handleTitleClick("nybyggnation")}
        >
          Nybyggnation av Hus
        </div>
        <div
          className="tjänster-TakTillGolv-1-parallax-image-232"
          onClick={() => handleTitleClick("nredningsdesign")}
        >
          Inredningsdesign och Dekorering
        </div>
        <div
          className="tjänster-TakTillGolv-1-parallax-image-232"
          onClick={() => handleTitleClick("ygg")}
        >
          Bygg och Renovering av Lägenheter
        </div>
        <div
          className="tjänster-TakTillGolv-1-parallax-image-232"
          onClick={() => handleTitleClick("industia")}
        >
          Industriella Byggprojekt
        </div>
        <div
          className="tjänster-TakTillGolv-1-parallax-image-232"
          onClick={() => handleTitleClick("olvläggning")}
        >
          Golvläggning och Golvrenovering
        </div>
        <div
          className="tjänster-TakTillGolv-1-parallax-image-232"
          onClick={() => handleTitleClick("akrenovering")}
        >
          Takrenovering och Takläggning
        </div>
        <div
          className="tjänster-TakTillGolv-1-parallax-image-232"
          onClick={() => handleTitleClick("ålning")}
        >
          Målning och Tapetseringstjänster
        </div>
        <div
          className="tjänster-TakTillGolv-1-parallax-image-232"
          onClick={() => handleTitleClick("örrinstallationer")}
        >
          Dörrinstallationer{" "}
        </div>

        <div
          className="tjänster-TakTillGolv-1-parallax-image-232"
          onClick={() => handleTitleClick("åsinstallation")}
        >
          Låsinstallation för alla typer av dörrar
        </div>
        <div
          className="tjänster-TakTillGolv-1-parallax-image-232"
          onClick={() => handleTitleClick("önsterinstallation")}
        >
          Fönsterinstallation{" "}
        </div>
        <div
          className="tjänster-TakTillGolv-1-parallax-image-232"
          onClick={() => handleTitleClick("äggreglering")}
        >
          Väggreglering och Byggmaterial
        </div>
        <div
          className="tjänster-TakTillGolv-1-parallax-image-232"
          onClick={() => handleTitleClick("adrumsrenovering")}
        >
          Badrumsrenovering och VVS-arbeten
        </div>
        <div
          className="tjänster-TakTillGolv-1-parallax-image-232"
          onClick={() => handleTitleClick("lreparationer")}
        >
          Elreparationer och Installationer
        </div>

        <div
          className="tjänster-TakTillGolv-1-parallax-image-232"
          onClick={() => handleTitleClick("äkerhets")}
        >
          Säkerhets- och Övervakningstjänster
        </div>

        <div
          className="tjänster-TakTillGolv-1-parallax-image-232"
          onClick={() => handleTitleClick("olpaneler")}
        >
          Solpaneler, Energi och Miljövänliga alternativ{" "}
        </div>

        <div
          className="tjänster-TakTillGolv-1-parallax-image-232"
          onClick={() => handleTitleClick("ordonsladdning")}
        >
          Fordonsladdning{" "}
        </div>

        <div
          className="tjänster-TakTillGolv-1-parallax-image-232"
          onClick={() => handleTitleClick("pecialiserade")}
        >
          Specialiserade Elarbeten{" "}
        </div>   </div>
      
        <img
          src={images[currentImageIndex]}
          alt={`TTGImage${currentImageIndex + 12}`}
          className="ttg-4-images-1"
        />
      </div>

      {!showSecondBox && (
        <button
          className="toggle-button5 show"
          onClick={handleScrollDownAndToggle}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
            >
              <path
                d="M41.25 24C41.25 24.1989 41.171 24.3897 41.0303 24.5303C40.8897 24.671 40.6989 24.75 40.5 24.75H24.75V40.5C24.75 40.6989 24.671 40.8897 24.5303 41.0303C24.3897 41.171 24.1989 41.25 24 41.25C23.8011 41.25 23.6103 41.171 23.4697 41.0303C23.329 40.8897 23.25 40.6989 23.25 40.5V24.75H7.5C7.30109 24.75 7.11032 24.671 6.96967 24.5303C6.82902 24.3897 6.75 24.1989 6.75 24C6.75 23.8011 6.82902 23.6103 6.96967 23.4697C7.11032 23.329 7.30109 23.25 7.5 23.25H23.25V7.5C23.25 7.30109 23.329 7.11032 23.4697 6.96967C23.6103 6.82902 23.8011 6.75 24 6.75C24.1989 6.75 24.3897 6.82902 24.5303 6.96967C24.671 7.11032 24.75 7.30109 24.75 7.5V23.25H40.5C40.6989 23.25 40.8897 23.329 41.0303 23.4697C41.171 23.6103 41.25 23.8011 41.25 24Z"
                fill="#000000"
              />
            </svg>{" "}
          </svg>
        </button>
      )}
      <div
        className={`TakTillGolv-tjänster-page-info ${
          showSecondBox ? "show" : "hide"
        }`}
        ref={secondBoxRef}
      >
        <div className="text-container-22">
          <div id="renovering">
            <h2 className="box-second-titles1">Renovering av Bostäder </h2>
            <div className="box-1-text1">
              Renovering av bostäder är en kärnverksamhet för oss på Tak Till
              Golv, och vi tar stolthet i att förvandla ditt hem till din
              drömboende. Vår expertis sträcker sig över alla aspekter av
              renoveringsprocessen, från den inledande planeringen och designen
              till det slutliga utförandet. Vi förstår att varje
              bostadsrenovering är unik, och vi anpassar våra tjänster för att
              möta dina specifika önskemål och behov. Vårt mål är att skapa en
              miljö som inte bara är vacker och funktionell, utan också en plats
              där du trivs och känner dig hemma.
              <br />
              <br />
              När du väljer Tak Till Golv för din bostadsrenovering kan du
              förvänta dig en sömlös och professionell upplevelse från början
              till slut. Vi arbetar nära med dig genom varje steg av processen
              för att säkerställa att din vision för ditt hem förverkligas på
              bästa möjliga sätt. Med vår breda erfarenhet och expertis inom
              byggbranschen kan du känna dig trygg med att din renovering kommer
              att utföras med högsta standard och uppmärksamhet på detaljer.
            </div>{" "}
            <div className="tak-till-golv-ttg-five-images-center-55">
              <img
                src={TTGImage17}
                alt="Image 8"
                className="tak-till-golv-ttg-five-image-center-55"
              />
            </div>
          </div>

          <div id="nybyggnation">
            <h2 className="box-second-titles1">Nybyggnation av Hus </h2>

            <div className="box-1-text1">
              Nybyggnation av hus är en spännande och betydelsefull process som
              vi på Tak Till Golv är specialiserade på. Vi förstår att ditt hem
              är mer än bara en byggnad - det är en plats där du skapar minnen
              och bygger din framtid. Med vår expertis och erfarenhet arbetar vi
              för att förverkliga dina visioner och skapa ett hem som är
              skräddarsytt efter dina behov och önskemål.
              <br />
              <br />
              När du väljer oss för din nybyggnation kan du lita på att du får
              en pålitlig partner som tar hand om alla detaljer, från den
              initiala planeringen och designen till den slutliga
              färdigställningen. Vi strävar efter att leverera högkvalitativa
              resultat som överträffar dina förväntningar och skapar en plats
              där du och din familj kan trivas och växa tillsammans. Med vårt
              dedikerade team av erfarna yrkesmän kan du vara säker på att din
              nybyggnation kommer att genomföras med precision och omsorg om
              detaljer.
            </div>
            <div className="tak-till-golv-ttg-five-images-center-55">
              <img
                src={TTGImage16}
                alt="Image 8"
                className="tak-till-golv-ttg-five-image-center-55"
              />
            </div>
          </div>
          <div id="nredningsdesign">
            <h2 className="box-second-titles1">
              Inredningsdesign och Dekorering
            </h2>
            <div className="box-1-text1">
              Inredningsdesign och dekorering är avgörande för att skapa en
              atmosfär som är både funktionell och estetiskt tilltalande. Hos
              Tak Till Golv tar vi oss an varje projekt med en passion för att
              skapa unika och personliga utrymmen som återspeglar våra kunders
              smak och livsstil. Vi arbetar nära med våra kunder för att förstå
              deras behov och önskemål, och sedan utforma och implementera
              skräddarsydda designlösningar som förbättrar både form och
              funktion.
              <br />
              <br />
              Vår erfarna designteam har en öga för detaljer och en känsla för
              stil, vilket gör att vi kan skapa rum som är både vackra och
              praktiska. Oavsett om det handlar om att skapa en avslappnad och
              inbjudande atmosfär i ditt hem eller att skapa ett professionellt
              och effektivt arbetsutrymme, kan du lita på oss för att leverera
              resultat av högsta kvalitet. Med vårt breda utbud av tjänster inom
              inredningsdesign och dekorering kan vi hjälpa dig att förvandla
              ditt hem eller företag till en plats som är både vacker och
              funktionell.
            </div>
            <div className="tak-till-golv-ttg-five-images-center-55">
              <img
                src={TTGImage19}
                alt="Image 19"
                className="tak-till-golv-ttg-five-image-center-55"
              />
            </div>
          </div>
          <div id="ygg">
            <h2 className="box-second-titles1">
              Bygg och Renovering av Lägenheter
            </h2>
            <div className="box-1-text1">
              Bygg och renovering av lägenheter är en av våra specialiteter på
              Tak Till Golv. Vi förstår vikten av att skapa ett hem som är både
              praktiskt och trivsamt, och vi arbetar nära med våra kunder för
              att förverkliga deras visioner. Vårt erfarna team av hantverkare
              och yrkesmän tar sig an varje projekt med precision och
              noggrannhet för att säkerställa att varje detalj är perfekt.
              <br />
              <br />
              Oavsett om det handlar om att renovera en äldre lägenhet för att
              återställa dess charm eller att bygga en helt ny lägenhet från
              grunden, kan du lita på oss för att leverera resultat av högsta
              kvalitet. Vi använder oss av de senaste teknikerna och materialen
              för att säkerställa att ditt hem är både vackert och hållbart. Med
              vår expertis och erfarenhet kan du känna dig trygg i att ditt
              projekt är i goda händer hos Tak Till Golv.
              <br />
              <br />
              Vårt fokus ligger inte bara på att skapa estetiskt tilltalande
              utrymmen utan också på att maximera funktionaliteten och komforten
              i dina bostäder. Vi tar hänsyn till varje detalj, från planering
              och design till utförande och färdigställande. Med vår breda
              erfarenhet och kreativa synsätt kan vi skapa unika och personliga
              utrymmen som passar din livsstil och behov perfekt. Oavsett om det
              handlar om att skapa en modern och elegant atmosfär eller att
              behålla den charm och karaktär som redan finns, är vi här för att
              göra din vision till verklighet. Med Tak Till Golv kan du vara
              säker på att din lägenhetsrenovering blir en smidig och
              framgångsrik process.
            </div>
            <div className="tak-till-golv-ttg-five-images-center-55">
              <img
                src={TTGImage21}
                alt="Image 21"
                className="tak-till-golv-ttg-five-image-center-55"
              />
            </div>
          </div>
          <div id="industia">
            <h2 className="box-second-titles1">Industriella Byggprojekt</h2>
            <div className="box-1-text1">
              Vår erfarenhet inom industriella byggprojekt sträcker sig över en
              mängd olika sektorer, vilket ger oss en bred kompetens och
              förståelse för de unika utmaningar som varje projekt kan innebära.
              Vi har framgångsrikt genomfört projekt inom områden som
              tillverkning, logistik, energi och mer, vilket ger oss en
              mångsidig portfölj och en djupgående kunskap om olika branschkrav
              och standarder.
              <br />
              <br />
              När det gäller industriella byggprojekt är effektivitet och
              noggrannhet avgörande. Vi använder avancerad teknik och beprövade
              metoder för att säkerställa att varje steg i processen utförs med
              högsta precision och kvalitet. Vårt team av erfarna yrkesmän och
              tekniker är välutbildade och certifierade för att hantera de mest
              krävande industriella miljöerna och uppgifterna.
              <br />
              <br />
              Vi är stolta över vår förmåga att leverera projekt i tid och inom
              budget, samtidigt som vi upprätthåller de högsta standarderna för
              säkerhet och kvalitet. Genom att arbeta nära med våra kunder och
              partners kan vi skapa skräddarsydda lösningar som uppfyller deras
              specifika behov och mål. Vi strävar efter att skapa långsiktiga
              relationer med våra kunder och att vara deras partner i framgång.
              <br />
              <br />
              Vår dedikation till kundtillfredsställelse är oöverträffad, och vi
              är stolta över det rykte vi har byggt upp som en pålitlig och
              ansedd aktör inom industriell byggsektor. Oavsett om det handlar
              om att bygga en ny anläggning, genomföra en omfattande renovering
              eller utföra regelbundet underhåll, kan du lita på oss för en
              professionell och pålitlig service som överträffar dina
              förväntningar.{" "}
            </div>
            <div className="tak-till-golv-ttg-five-images-center-55">
              <img
                src={TTGImage23}
                alt="Image 23"
                className="tak-till-golv-ttg-five-image-center-55"
              />
            </div>
          </div>
          <div id="olvläggning">
            <h2 className="box-second-titles1">
              Golvläggning och Golvrenovering
            </h2>
            <div className="box-1-text1">
              Vår expertis inom golvläggning och golvrenovering sträcker sig
              över en mångfald olika material och designkoncept för att möta
              våra kunders unika behov och önskemål. Vi erbjuder en omfattande
              tjänst som täcker allt från planering och förberedelse till
              installation och eftervård av olika golvläggningar.
              <br />
              <br />
              När det gäller golvläggning är noggrannhet och precision avgörande
              för ett lyckat resultat. Vårt team av erfarna hantverkare och
              golvläggare har den kompetens och kunskap som krävs för att
              säkerställa att varje projekt utförs med högsta kvalitet och
              professionalism. Vi arbetar med en mängd olika material, inklusive
              trä, laminat, klinker, och vinyl, och kan skapa skräddarsydda
              lösningar som passar varje kunds unika smak och stil.
              <br />
              <br />
              Golvrenovering är också en viktig del av vårt tjänsteutbud, och vi
              har lång erfarenhet av att återställa och förbättra befintliga
              golv till sin fulla potential. Oavsett om det handlar om att slipa
              och lacka trägolv, reparera skador eller helt enkelt fräscha upp
              ytan med en ny beläggning, kan du lita på oss för en professionell
              och pålitlig service som återställer dina golv till sitt bästa
              skick.
              <br />
              <br />
              Vi strävar efter att erbjuda våra kunder en stressfri och smidig
              upplevelse genom hela processen, från början till slut. Vi tar
              hand om allt det administrativa arbetet och ser till att varje
              steg utförs med noggrannhet och uppmärksamhet på detaljer. Med
              vårt engagemang för kundtillfredsställelse och vår passion för
              perfektion är vi redo att ta itu med alla dina golvläggnings- och
              golvrenoveringsbehov.
            </div>
            <div className="tak-till-golv-ttg-five-images-center-55">
              <img
                src={TTGImage22}
                alt="Image 22"
                className="tak-till-golv-ttg-five-image-center-55"
              />
            </div>
          </div>
          <div id="akrenovering">
            <h2 className="box-second-titles1">
              Takrenovering och Takläggning{" "}
            </h2>
            <div className="box-1-text1">
              Vår takrenoverings- och takläggningstjänst är en nyckeldel av vårt
              erbjudande som byggföretag. Vi förstår vikten av att ha ett
              hållbart och välfungerande tak för att skydda ditt hem eller
              företag från väder och vind. Med vår expertis och erfarenhet
              erbjuder vi skräddarsydda lösningar för takrenovering och
              takläggning som uppfyller våra kunders behov och önskemål.
              <br />
              <br />
              Vi arbetar med olika typer av takmaterial, inklusive tegel,
              betong, metall och takpapp, och kan rekommendera den bästa
              lösningen baserat på dina specifika krav och budget. Vårt erfarna
              team av takläggare och hantverkare har den kunskap och kompetens
              som krävs för att säkerställa att varje takprojekt utförs med
              högsta kvalitet och professionalism.
              <br />
              <br />
              Vi tar hand om alla aspekter av takrenoveringen och takläggningen,
              från inspektion och planering till materialval och installation.
              Vi använder oss av de senaste teknikerna och metoderna för att
              säkerställa att ditt tak är hållbart, säkert och energieffektivt.
              Vårt mål är att leverera resultat av högsta kvalitet som
              överträffar dina förväntningar och ger dig lugn och trygghet i
              många år framöver.
              <br />
              <br />
              Oavsett om du behöver en helt ny takläggning eller bara en
              renovering av ditt befintliga tak, kan du lita på oss för en
              professionell och pålitlig service som är skräddarsydd efter dina
              behov. Med vårt engagemang för kundtillfredsställelse och vår
              passion för perfektion är vi redo att ta itu med alla dina
              takrenoverings- och takläggningsprojekt.
            </div>
            <div className="tak-till-golv-ttg-five-images-center-55">
              <img
                src={TTGImage24}
                alt="Image 24"
                className="tak-till-golv-ttg-five-image-center-55"
              />
            </div>
          </div>
          <div id="ålning">
            <h2 className="box-second-titles1">
              Målning och Tapetseringstjänster{" "}
            </h2>
            <div className="box-1-text1">
              Vår målnings- och tapetseringstjänst är en av de hörnstenar som
              definierar vårt byggföretag. Vi förstår att målning och
              tapetsering är avgörande för att ge ditt hem eller företag den
              önskade estetiska känslan och finishen. Med vår expertis och
              erfarenhet erbjuder vi skräddarsydda lösningar som förvandlar dina
              utrymmen till verkliga mästerverk.
              <br />
              <br />
              Vi arbetar med en mångfald av målnings- och tapetseringsprojekt,
              från små rum till stora kommersiella fastigheter. Oavsett om det
              är att måla om ditt vardagsrum i en ny färg eller att tapetsera om
              kontorets väggar för att skapa en mer professionell atmosfär, kan
              vårt erfarna team av målare och tapetserare ta sig an alla typer
              av utmaningar.
              <br />
              <br />
              Vi använder oss av högkvalitativa färger, lacker och tapeter för
              att säkerställa att resultatet blir långvarigt och hållbart. Vår
              noggranna förberedelse och tillämpningsteknik garanterar en jämn
              och jämn yta utan fläckar eller ojämnheter. Vi strävar efter att
              leverera ett slående utseende som förbättrar ditt utrymme och ger
              dig glädje och stolthet i många år framöver.
              <br />
              <br />
              Vårt mål är att göra målnings- och tapetseringsprocessen så smidig
              och bekymmersfri som möjligt för våra kunder. Vi tar hand om allt
              från att förbereda ytan och skydda dina möbler till att rengöra
              och städa upp efter avslutat arbete. Med vår professionella och
              pålitliga service kan du lita på oss för att leverera enastående
              resultat varje gång.
            </div>
            <div className="tak-till-golv-ttg-five-images-center-55">
              <img
                src={ttgimage18}
                alt="Image 18"
                className="tak-till-golv-ttg-five-image-center-55"
              />
            </div>
          </div>
          <div id="örrinstallationer">
            <h2 className="box-second-titles1">Dörrinstallationer </h2>
            <div className="box-1-text1">
              Vid Tak Till Golv erbjuder vi omfattande expertis när det gäller
              dörrinstallationer för både ytter- och innerdörrar. Vi strävar
              efter att leverera professionella och pålitliga lösningar som
              passar våra kunders unika behov och förväntningar.
              <br />
              <br />
              När det kommer till ytterdörrar är säkerhet och stil lika viktiga
              faktorer. Vårt erfarna team kan hjälpa dig att välja den perfekta
              ytterdörren som inte bara förbättrar säkerheten för ditt hem, utan
              också kompletterar dess estetik. Vi installerar dörrar av högsta
              kvalitet som är slitstarka och tåliga mot väder och yttre
              påverkan.
              <br />
              <br />
              För innerdörrar erbjuder vi ett brett utbud av stilar och material
              för att passa olika inredningsstilar och behov. Oavsett om du
              letar efter traditionella trädörrar, moderna glasdörrar eller
              något annat, kan vårt team hjälpa dig att hitta rätt alternativ
              och installera det på ett professionellt sätt.
              <br />
              <br />
              Med Tak Till Golv kan du vara säker på att din dörrinstallation
              utförs med högsta precision och omsorg. Vi tar hänsyn till varje
              detalj för att säkerställa att din dörr inte bara ser fantastisk
              ut, utan också fungerar perfekt för många år framöver.
            </div>
            <div className="tak-till-golv-ttg-five-images-center-55">
              <img
                src={TTGImage31}
                alt="Image 31"
                className="tak-till-golv-ttg-five-image-center-55"
              />
            </div>
          </div>
          <div id="örrinstallationer">
            <h2 className="box-second-titles1">
              Låsinstallation för alla typer av dörrar{" "}
            </h2>
            <div className="box-1-text1">
              Hos Tak Till Golv är vi experter på att säkerställa din trygghet
              och säkerhet genom professionell låsinstallation för både ytter-
              och innerdörrar. Vi erbjuder ett brett utbud av låsalternativ för
              att möta våra kunders unika behov och önskemål, oavsett om det är
              för hemmet, kontoret eller butiken.
              <br />
              <br />
              När det gäller ytterdörrar är det avgörande att ha säkra och
              pålitliga lås för att skydda ditt hem och dess invånare. Vårt
              erfarna team kan rekommendera och installera högkvalitativa lås
              som ger maximal säkerhet och fred i sinnet. Vi ser till att varje
              lås är korrekt monterat och fungerar smidigt för att förhindra
              obehörig åtkomst och öka säkerheten.
              <br />
              <br />
              För innerdörrar erbjuder vi också professionell låsinstallation
              för att förbättra integriteten och skyddet av ditt utrymme.
              Oavsett om det är ett traditionellt nyckellås, ett modernare
              kodlås eller ett elektroniskt låssystem, kan vi installera det på
              ett noggrant och professionellt sätt för att säkerställa optimal
              funktion och säkerhet.
              <br />
              <br />
              Med vår expertis och erfarenhet kan du lita på att din
              låsinstallation utförs på ett proffsigt sätt. Vi strävar efter att
              leverera högsta kvalitet och service för att säkerställa att ditt
              hem eller företag är väl skyddat och säkert.
            </div>
            <div className="tak-till-golv-ttg-five-images-center-55">
              <img
                src={TTGImage32}
                alt="Image 32"
                className="tak-till-golv-ttg-five-image-center-55"
              />
            </div>
          </div>
          <div id="önsterinstallation">
            <h2 className="box-second-titles1">Fönsterinstallation </h2>
            <div className="box-1-text1">
              Tak Till Golv är din pålitliga partner när det gäller
              fönsterinstallation för både ytter- och innerfönster. Vi erbjuder
              en omfattande tjänst för att säkerställa att dina fönster
              installeras på ett professionellt och effektivt sätt, oavsett
              storlek eller typ.
              <br />
              <br />
              När det kommer till ytterfönster är det viktigt att ha
              högkvalitativa och energieffektiva alternativ för att förbättra
              isoleringen och minska energiförluster i ditt hem eller företag.
              Vårt erfarna team kan hjälpa dig att välja rätt fönster för dina
              behov och installera dem med precision och noggrannhet för att
              säkerställa långvarig prestanda och estetiskt tilltalande
              resultat.
              <br />
              <br />
              För innerfönster erbjuder vi också skräddarsydda lösningar för att
              förbättra ljusinsläppet och ventilationen i ditt utrymme. Oavsett
              om det är för ett kontor, ett kök eller ett vardagsrum, kan vi
              installera innerfönster på ett proffsigt sätt för att möta dina
              krav och önskemål.
              <br />
              <br />
              Med vår expertis och dedikation kan du vara säker på att din
              fönsterinstallation utförs med högsta precision och
              professionalism. Vi strävar efter att leverera överlägsen service
              och kvalitet för att säkerställa att dina fönster inte bara ser
              bra ut, utan också fungerar optimalt för att förbättra komforten
              och effektiviteten i ditt hem eller företag.
            </div>
            <div className="tak-till-golv-ttg-five-images-center-55">
              <img
                src={TTGImage33}
                alt="Image 33"
                className="tak-till-golv-ttg-five-image-center-55"
              />
            </div>
          </div>
          <div id="äggreglering">
            <h2 className="box-second-titles1">
              Väggreglering och Byggmaterial{" "}
            </h2>
            <div className="box-1-text1">
              När det gäller väggreglering och byggmaterial är vi din pålitliga
              partner för att säkerställa att ditt byggprojekt uppfyller alla
              gällande normer och standarder. Vi förstår att rätt val av
              byggmaterial och korrekt installation av väggreglering är
              avgörande för att säkerställa säkerhet, hållbarhet och långsiktig
              prestanda för ditt projekt.
              <br />
              <br />
              Vårt team av experter har omfattande kunskap och erfarenhet av att
              arbeta med olika typer av väggreglering och byggmaterial. Vi
              erbjuder skräddarsydda lösningar som passar dina specifika behov
              och projektkrav. Oavsett om det handlar om att installera
              trafikskyltar och vägmarkeringar för att säkerställa smidig
              trafikflöde eller att välja rätt byggmaterial för att förbättra
              strukturell integritet och estetiskt utseende, kan du lita på oss
              för expertis och professionalism.
              <br />
              <br />
              Vi samarbetar med ledande leverantörer och tillverkare för att
              säkerställa att vi använder högkvalitativa och hållbara
              byggmaterial som är lämpliga för ditt projekt. Vi utför noggranna
              kontroller och tester för att garantera att alla material
              uppfyller branschstandarder och att installationen utförs enligt
              bästa praxis.
              <br />
              <br />
              Med vår dedikation till kvalitet, säkerhet och service kan du vara
              säker på att ditt byggprojekt är i goda händer. Vi strävar efter
              att leverera överlägsna resultat som överträffar dina
              förväntningar och bidrar till att skapa säkra, funktionella och
              hållbara byggnader och infrastrukturer.
            </div>{" "}
            <div className="tak-till-golv-ttg-five-images-center-55">
              <img
                src={TTGImage20}
                alt="Image 20"
                className="tak-till-golv-ttg-five-image-center-55"
              />
            </div>
          </div>
          <div id="adrumsrenovering">
            <h2 className="box-second-titles1">
              Badrumsrenovering och VVS-arbeten
            </h2>
            <div className="box-1-text1">
              När det gäller badrumsrenovering och VVS-arbeten är vi din
              pålitliga partner för att skapa funktionella, eleganta och
              hållbara badrumslösningar. Vi förstår att badrummet är en viktig
              del av ditt hem, och vi strävar efter att leverera renoveringar
              och VVS-tjänster som uppfyller dina behov och önskemål på bästa
              möjliga sätt.
              <br />
              <br />
              Vårt erfarna team av hantverkare och VVS-tekniker har
              expertkunskap och kompetens för att genomföra alla typer av
              badrumsrenoveringar och VVS-arbeten. Oavsett om du vill skapa ett
              lyxigt spa-liknande badrum eller behöver en enkel uppgradering av
              din befintliga installation, kan du lita på oss för att leverera
              professionella resultat.
              <br />
              <br />
              Vi erbjuder ett brett utbud av tjänster, inklusive installation av
              badrumsinredning, VVS-förbättringar, rörmokeri, avloppsrensning,
              och mycket mer. Vi arbetar med noggrannhet och precision för att
              säkerställa att alla arbeten utförs enligt högsta standard och att
              alla VVS-installationer fungerar korrekt och effektivt.
              <br />
              <br />
              Vårt mål är att skapa badrum som inte bara är vackra att se på,
              utan också praktiska och funktionella för din vardag. Vi strävar
              efter att skapa badrumslösningar som möter dina behov och önskemål
              samtidigt som de är hållbara och långvariga. Med vår expertis och
              dedikation kan du vara säker på att ditt badrumsrenoveringsprojekt
              är i goda händer.
            </div>
            <div className="tak-till-golv-ttg-five-images-center-55">
              <img
                src={TTGImage25}
                alt="Image 25"
                className="tak-till-golv-ttg-five-image-center-55"
              />
            </div>
          </div>

          <div id="lreparationer">
            <h2 className="box-second-titles1">
              Elreparationer och Installationer:
            </h2>

            <div className="box-1-text1-21">Elreparationer</div>

            <div className="box-1-text1">
              Elreparationer innefattar alla typer av reparationer som krävs för
              att säkerställa att din elanläggning fungerar säkert och
              effektivt. Det kan innebära att åtgärda felaktiga ledningar, byta
              ut trasiga eluttag eller brytare, eller reparera skadade kablar.
              Professionella elektriker kan snabbt identifiera och åtgärda
              problem med din elanläggning för att säkerställa att den uppfyller
              säkerhetsnormer och fungerar optimalt.
              <div className="box-1-text1-21">Strömbrytare</div>
              <div className="box-1-text1">
                Elreparationer innefattar alla typer av reparationer som krävs
                för att säkerställa att din elanläggning fungerar säkert och
                effektivt. Det kan innebära att åtgärda felaktiga ledningar,
                byta ut trasiga eluttag eller brytare, eller reparera skadade
                kablar. Professionella elektriker kan snabbt identifiera och
                åtgärda problem med din elanläggning för att säkerställa att den
                uppfyller säkerhetsnormer och fungerar optimalt.
                <div className="box-1-text1-21">Belysning</div>
                <div className="box-1-text1">
                  Belysning är en viktig del av alla byggnaders elsystem och
                  påverkar både estetik och funktionalitet. Professionella
                  elektriker kan hjälpa till med allt från att installera nya
                  ljuskällor och armaturer till att utföra underhåll och
                  reparationer av befintliga belysningsanläggningar. Med rätt
                  belysningsdesign kan du skapa den perfekta atmosfären i ditt
                  hem, kontor eller affärslokal.
                  <div className="box-1-text1-21">Industriinstallationer</div>
                  <div className="box-1-text1">
                    Industriella installationer kräver specialiserad kunskap och
                    erfarenhet för att säkerställa att de uppfyller industriella
                    standarder och säkerhetskrav. Det kan innefatta installation
                    av elutrustning och maskiner, kablage och
                    kraftfördelningssystem, samt övervakning och underhåll av
                    industriella elsystem. Professionella elektriker med
                    erfarenhet av industriinstallationer kan hantera komplexa
                    projekt och säkerställa att din anläggning uppfyller alla
                    krav och bestämmelser.
                    <div className="box-1-text1-21">Telefoninstallationer</div>
                    <div className="box-1-text1">
                      Telefoninstallationer innefattar installation, reparation
                      och underhåll av telefon- och kommunikationssystem i
                      hemmet eller på arbetsplatsen. Det kan inkludera
                      installation av telefonuttag, kablage och
                      nätverksinfrastruktur, samt konfiguration och felsökning
                      av telefonapparater och system. En professionell
                      elektriker kan hjälpa till med att skapa en pålitlig och
                      effektiv telefoninfrastruktur för att möta dina
                      kommunikationsbehov.
                      <div className="box-1-text1-21">Datainstallationer</div>
                      <div className="box-1-text1">
                        Datainstallationer omfattar installation och
                        konfiguration av datanätverk och IT-infrastruktur för
                        att säkerställa snabb och pålitlig dataöverföring och
                        kommunikation. Det kan inkludera installation av
                        nätverkskablage, routrar, switchar och andra
                        nätverksenheter, samt konfiguration och optimering av
                        nätverksinställningar och säkerhetsprotokoll.
                        Professionella elektriker med erfarenhet av
                        datainstallationer kan hjälpa till med att skapa en
                        robust och säker IT-infrastruktur för ditt hem eller
                        företag.
                      </div>{" "}
                    </div>{" "}
                  </div>
                </div>
              </div>
            </div>
            <div className="tak-till-golv-ttg-five-images-center-55">
              <img
                src={TTGImage26}
                alt="Image 8"
                className="tak-till-golv-ttg-five-image-center-55"
              />
            </div>
          </div>

          <div id="äkerhets">
            <h2 className="box-second-titles1">
              Säkerhets- och Övervakningstjänster{" "}
            </h2>

            <div className="box-1-text1-21">Installation av Inbrottslarm</div>

            <div className="box-1-text1">
              Vi erbjuder skräddarsydda lösningar för installation av
              inbrottslarm som är utformade för att passa dina unika
              säkerhetsbehov. Våra experter kan rekommendera och installera det
              perfekta inbrottslarmssystemet för att skydda ditt hem eller
              företag mot intrång och stölder.
              <div className="box-1-text1-21">
                Installation av Övervakningskameror
              </div>
              <div className="box-1-text1">
                Våra professionella tekniker kan installera och konfigurera
                övervakningskameror på strategiska platser för att övervaka och
                övervaka olika områden. Med högupplösta kameror och avancerad
                teknik kan du ha full kontroll och överblick över ditt hem eller
                företag, oavsett var du befinner dig.
                <div className="box-1-text1-21">Integration av Larmsystem</div>
                <div className="box-1-text1">
                  Vi specialiserar oss även på att integrera olika
                  säkerhetssystem, inklusive larmsystem och övervakningskameror,
                  för en heltäckande säkerhetslösning. Genom att integrera olika
                  säkerhetsenheter kan vi skapa ett effektivt och pålitligt
                  säkerhetssystem som ger dig maximal trygghet och fred i
                  sinnet.
                  <br></br>
                  <br></br>
                  Med våra professionella installations- och
                  integreringstjänster kan du vara säker på att ditt
                  säkerhetssystem är korrekt installerat och optimerat för
                  maximal prestanda och tillförlitlighet. Vi strävar efter att
                  erbjuda dig den bästa möjliga säkerhetslösningen för att
                  skydda det som är viktigt för dig.
                </div>
              </div>
            </div>
            <div className="tak-till-golv-ttg-five-images-center-55">
              <img
                src={TTGImage27}
                alt="Image 8"
                className="tak-till-golv-ttg-five-image-center-55"
              />
            </div>
          </div>

          <div id="olpaneler">
            <h2 className="box-second-titles1">
              Solpaneler, Energi och Miljövänliga alternativ{" "}
            </h2>

            <div className="box-1-text1-21">
              Installation av solceller och solpaneler
            </div>

            <div className="box-1-text1">
              Vårt engagerade team av experter är dedikerade till att leverera
              högkvalitativa installationer av solceller och solpaneler som inte
              bara minskar din miljöpåverkan utan också sänker dina
              energikostnader på lång sikt. Med vår noggranna planering och
              skickliga utförande kan du känna dig trygg med att din
              solenergilösning är installerad på bästa möjliga sätt.
              <div className="box-1-text1-21">
                Effektivisera ditt hem med KNX
              </div>
              <div className="box-1-text1">
                Vi erbjuder skräddarsydda lösningar för att effektivisera ditt
                hem med det avancerade KNX-systemet. Genom att integrera smarta
                teknologier kan vi automatisera och optimera energiförbrukningen
                i ditt hem, vilket inte bara minskar dina driftskostnader utan
                också ökar din komfort och bekvämlighet. Med vår expertis kan du
                förvandla ditt hem till en miljövänlig och intelligent
                bostadsmiljö.
                <br></br>
                <br></br>
                Oavsett om det gäller solenergi eller smarta hemlösningar, är vi
                här för att guida dig genom hela processen, från planering och
                design till installation och underhåll. Lita på oss för att
                leverera pålitliga och hållbara lösningar som uppfyller dina
                behov och önskemål samtidigt som de bidrar till en grönare
                framtid.
              </div>
            </div>
            <div className="tak-till-golv-ttg-five-images-center-55">
              <img
                src={TTGImage28}
                alt="Image 8"
                className="tak-till-golv-ttg-five-image-center-55"
              />
            </div>
          </div>

          <div id="ordonsladdning">
            <h2 className="box-second-titles1">Fordonsladdning </h2>
            <div className="box-1-text1">
              Vi på Tak Till Golv är stolta över att erbjuda ett brett utbud av
              fordonsladdningslösningar för både privat och kommersiellt bruk.
              Med vår expertis och erfarenhet kan vi hantera alla aspekter av
              fordonsladdning, från installation av laddstationer till
              försäljning av laddboxar av högsta kvalitet.
              <div className="box-1-text1-21">Laddboxar - DC </div>
              <div className="box-1-text1">
                Våra DC-laddboxar är utformade för att leverera snabb och
                effektiv laddning för dina fordon. Med laddstationer som
                sträcker sig från 11 till 24 kW kan vi säkerställa att dina
                fordon laddas på kortast möjliga tid, vilket ger dig mer tid på
                vägen och mindre tid vid laddstationen. För kommersiella
                applikationer erbjuder vi även snabbladdare med effekter från 50
                till 350 kW+, vilket gör dem idealiska för snabb och pålitlig
                laddning vid högtrafikerade platser.
              </div>
              <div className="box-1-text1-21">Laddboxar - AC </div>
              <div className="box-1-text1">
                Våra AC-laddboxar är perfekta för hemmabruk och mindre
                kommersiella installationer. Med laddstationer som sträcker sig
                från 3 till 22 kW kan vi erbjuda flexibel och pålitlig laddning
                för dina fordon. Våra AC-laddboxar är också kompatibla med vårt
                specialteknologiska system som kopplar dem direkt till
                solpaneler för miljövänlig och hållbar laddning.
              </div>
              <div className="box-1-text1-21">
                Specialteknologi med solpaneler
              </div>
              <div className="box-1-text1">
                Vi erbjuder en innovativ lösning som kombinerar våra laddboxar
                med solpaneler för att möjliggöra direkt laddning från
                solenergi. Genom att sammankoppla solpaneler med AC-laddboxar
                kan vi eliminera behovet av mellanliggande elbolag och
                möjliggöra direkt laddning från solenergi till dina fordon.
                Detta ger en miljövänlig och kostnadseffektiv laddningslösning
                som minskar din beroende av traditionell el och bidrar till en
                mer hållbar framtid.
                <br></br>
                <br></br>
                Tak Till Golv är din pålitliga partner för alla dina
                fordonsladdningsbehov. Oavsett om det är installation av
                laddstationer, försäljning av laddboxar eller specialiserade
                solenergilösningar, kan du lita på oss för professionell service
                och högkvalitativa produkter. För att se vårt breda utbud av
                laddboxar av både AC och DC, besök vår märke på
                <a className="Hev12eaGrip" href="https://heveagrip.com/">
                  Hevea Grip
                </a>
                . Där kan du utforska alla tillgängliga laddningsalternativ och
                hitta den perfekta lösningen för dina behov.
              </div>
            </div>
            <div className="tak-till-golv-ttg-five-images-center-55">
              <img
                src={TTGImage29}
                alt="Image 8"
                className="tak-till-golv-ttg-five-image-center-55"
              />
            </div>
          </div>
          <div id="pecialiserade">
            <h2 className="box-second-titles1">Specialiserade Elarbeten </h2>
            <div className="box-1-text1">
              Tak Till Golv erbjuder en omfattande expertis inom specialiserade
              elarbeten för en mängd olika miljöer, inklusive industriella
              anläggningar, kontor och butiker. Vår erfarna och kunniga personal
              är skicklig inom alla aspekter av elinstallationer och strävar
              alltid efter att leverera högkvalitativa resultat som uppfyller
              våra kunders behov och förväntningar.
              <br />
              <br />
              När det gäller industriella elarbeten kan vi hantera allt från
              storskaliga elinstallationer till underhåll och reparationer av
              befintliga system. Vi förstår vikten av tillförlitlig och effektiv
              el i industriella anläggningar och arbetar hårt för att
              säkerställa att våra kunder har en stabil och säker elförsörjning.
              <br />
              <br />
              För kontor och butiker erbjuder vi skräddarsydda elinstallationer
              som passar specifika behov och krav för varje verksamhet. Oavsett
              om det handlar om att installera belysningssystem, eluttag eller
              säkerhetssystem, kan vårt team leverera snabb och professionell
              service för att säkerställa att din arbetsplats är säker och
              funktionell.
              <br />
              <br />
              Med Tak Till Golv som din partner för specialiserade elarbeten kan
              du vara säker på att dina elbehov hanteras av erfarna och
              pålitliga yrkesmän. Vi strävar alltid efter att leverera
              högkvalitativa lösningar som uppfyller branschstandarder och
              överträffar våra kunders förväntningar.
            </div>
            <div className="tak-till-golv-ttg-five-images-center-55">
              <img
                src={TTGImage30}
                alt="Image 22"
                className="tak-till-golv-ttg-five-image-center-55"
              />
            </div>
          </div>
          <button className="close-button5" onClick={handleCloseSecondBox}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="68"
              height="68"
              viewBox="0 0 68 68"
              fill="none"
            >
              <path
                d="M46.1978 21.8024C46.3384 21.9431 46.4174 22.1338 46.4174 22.3327C46.4174 22.5317 46.3384 22.7224 46.1978 22.8631L35.0608 34L46.1978 45.1369C46.3384 45.2776 46.4174 45.4683 46.4174 45.6673C46.4174 45.8662 46.3384 46.0569 46.1978 46.1976C46.0571 46.3382 45.8663 46.4173 45.6674 46.4173C45.4685 46.4173 45.2777 46.3382 45.1371 46.1976L34.0002 35.0607L22.8632 46.1976C22.7226 46.3382 22.5318 46.4173 22.3329 46.4173C22.134 46.4173 21.9432 46.3382 21.8026 46.1976C21.6619 46.0569 21.5829 45.8662 21.5829 45.6673C21.5829 45.4683 21.6619 45.2776 21.8026 45.1369L32.9395 34L21.8026 22.8631C21.6619 22.7224 21.5829 22.5317 21.5829 22.3327C21.5829 22.1338 21.6619 21.9431 21.8026 21.8024C21.9432 21.6618 22.134 21.5827 22.3329 21.5827C22.5318 21.5827 22.7226 21.6618 22.8632 21.8024L34.0002 32.9393L45.1371 21.8024C45.2777 21.6618 45.4685 21.5827 45.6674 21.5827C45.8663 21.5827 46.0571 21.6618 46.1978 21.8024Z"
                fill="#000000"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default TjänsterArbeteTakTillGolv;
